import { AppBar } from '@floriday/floriday-ui'
import { RfhLogo } from '../RfhLogo'

import { LogisticMeansPortalUserMenu } from './LogisticMeansPortalUserMenu'

type LogisticMeansPortalAppbarProps = {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export const LogisticMeansPortalAppbar = ({
  setOpen,
}: LogisticMeansPortalAppbarProps) => {
  const handleToggleSidebar = () => {
    setOpen(prev => !prev)
  }

  return (
    <AppBar
      menuButtonActive={false}
      menuButtonVisibility={'always'}
      onMenuButtonClick={handleToggleSidebar}
      logo={<RfhLogo />}
      monochromeTheme
      rightContent={<LogisticMeansPortalUserMenu />}
    />
  )
}
